import { render, staticRenderFns } from "./Emp.vue?vue&type=template&id=22ccee5b"
import script from "./Emp.vue?vue&type=script&lang=js"
export * from "./Emp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports